import * as React from 'react';
import { observer } from 'mobx-react';
import { FindTicketByNumberComponent } from 'desktop--design-library';
import { IFindTicketByNumber } from 'eTip--common';

export interface IFindTicketByNumberProps {
    store: IFindTicketByNumber;
    pushToTicketDetailByNumber: (ticketId: string) => void;
}

@observer
export class FindTicketByNumberContainer extends React.Component<IFindTicketByNumberProps> {

    private handleTextChange = (text: string) => {
        this.props.store.setTicketNumberText(text);
    }

    constructor(props: IFindTicketByNumberProps) {
        super(props);
    }

    render() {
        return (
            <FindTicketByNumberComponent
                ticketNumber={this.props.store.ticketNumber}
                onTicketNumberChange={(text: string) => { this.handleTextChange(text); }}
                onGo={() => { this.props.pushToTicketDetailByNumber(this.props.store.ticketNumber); this.props.store.setTicketNumberText(""); }}
            />)
    }
}